export const STATUS_PENDING = 'Pending';
export const STATUS_COMPLETED = 'completed';
export const STATUS_FAILED = 'failed';
export const STATUS_SUCCESS = 'Success';
export const STATUS_FAILURE = 'Failure';
export const STATUS_RESET = 'Reset';
export const STATUS_FAIL = "fail";
export const CLOUD_FILE_PATH_SEPARATOR = "/";
export const EMPTY_FOLDER_MESSAGE = 'This folder is empty.';
export const SELECT_DEFAULT_PATH_MESSAGE = 'Select a default path from the left.';
export const INSTRUMENT_STATUS_CONNECTED = "connected";
export const ROUTE_DASHBOARD = "/dashboard/";
export const ROUTE_DASHBOARD_PATH = ROUTE_DASHBOARD + ":instanceId";
export const ROUTE_SITE_VIEW = "/siteView/";
export const ROUTE_SITE_VIEW_PATH = ROUTE_SITE_VIEW + ":instanceId";
export const ROUTE_FILES = "/files/"
export const ROUTE_FILES_PATH = ROUTE_FILES + ":instanceId"
export const ROUTE_HOME = "/home";
export const ROUTE_METRICS = "/metrics";
export const ROUTE_ADMIN = "/admin";
export const ROUTE_RSU = "/modList";
export const ROUTE_METER="/metering";
export const ROUTE_WATCHLIST = "/watchlist";
export const ROUTE_TRIGGERS="/trigger";
export const ROUTE_RULE_LIST="/ruleList/";
export const ROUTE_RULE_LIST_PATH = ROUTE_RULE_LIST + ":instanceId";


export const ROUTE_TRIGGERS_PATH = "/trigger/:instanceId";
export const ROUTE_RB_REPORT_PATH = "/RBReports/:deviceId/:rbDate/:rbId/:modelName";
export const ROUTE_ISE_CAL_REPORTS_PATH = "/iseCalReport/:deviceId/:calibrationDate/:calibrationId";
export const ROUTE_CHEM_CAL_REPORTS_PATH = "/chemCalReport/:deviceId/:calibrationDate/:calibrationId";
export const ROUTE_RSU_SOFTWARE_LIST = "/softwareList";
export const ROUTE_RSU_UPLOAD = "/uploadSoftware";
export const ROUTE_PIPETTOR_MATCH_REPORT_PATH = "/instrument/diagnosticdata/pipettormatch/report/:deviceId/:selectedDateTime/:model/:region/:timezone/:outcome/:diagnosticrunType/:notes/:serialNumber/:unit";
export const ROUTE_PIPETTOR_MATCH_REPORT_SIMPLE_PATH = "/instrument/diagnosticdata/pipettormatch/report";
export const ROUTE_CARRYOVER_REPORT_PATH = "/instrument/diagnosticdata/carryover/report/:deviceId/:selectedDateTime/:model/:region/:timezone/:outcome/:notes/:serialNumber/:unit";
export const ROUTE_CARRYOVER_REPORT_SIMPLE_PATH = "/instrument/diagnosticdata/carryover/report";
export const ROUTE_LOWVOLUME_REPORT_PATH = "/instrument/diagnosticdata/lowvolume/report/:deviceId/:selectedDateTime/:model/:region/:timezone/:outcome/:diagnosticrunType/:notes/:serialNumber/:unit";
export const ROUTE_LOWVOLUME_REPORT_SIMPLE_PATH = "/instrument/diagnosticdata/lowvolume/report";
export const ROUTE_SYSTEM_CHECK_REPORT_PATH = "/instrument/diagnosticdata/systemcheck/report/:deviceId/:selectedDateTime/:model/:region/:timezone/:outcome/:notes/:serialNumber/:unit";
export const ROUTE_SYSTEM_CHECK_REPORT_SIMPLE_PATH = "/instrument/diagnosticdata/systemcheck/report";
export const ROUTE_RM_REPORT_SIMPLE_PATH = "/Instrument/subfeatures/ReactionMonitor/report";
export const ROUTE_RM_ALL_WAVELENGTHS_SIMPLE_PATH = "/Instrument/subfeatures/ReactionMonitor/allwavelengths";

export const ROUTE_USER_SERACH_HISTORY = "/history";
export const FEATURE_ACCESS_DENIED_ERROR_MESSAGE = "You do not have access to the application feature. Please contact DxS IntelliServe support team to request access";
export const AUTH_OBJECT_KEY_NAME = "AUTH_OBJECT";
export const STATUS_DELETED = "Deleted";
export const STANDARD_DATE_TIME_FORMAT = 'DD/MMM/YYYY HH:mm:ss';
export const DAY_DATE_TIME_FORMAT = 'DD, HH:mm:ss';
export const QC_DATE_TIME_FORMAT = "DD MMM YYYY HH:mm:ss";
export const EXPORT_DATE_TIME_FORMAT_REPORT = "DDMMMYYYYHHmmss";
export const STANDARD_DATE_FORMAT = 'DD/MMM/YYYY';
export const STATUS_CANCELLED = "cancelled";
export const FEATURES = {
    RSU:"rsu",
    RDS:"rds",
    FILE_UPLOAD:"fileupload",
    FILE_TRANSFER:"filetransfer",
    FILE_DOWNLOAD:"filedownload",
    DASHBOARD:"dashboard",
    HOMEPAGE:"homepage",
    RSU_SW_VIEW:"rsu_sw_view",
    RSU_SW_DOWNLOAD:"rsu_sw_download",
    RSU_SW_STOPSHIP:"rsu_sw_stopship",
    RSU_SW_UPLOAD:"rsu_sw_upload",
    RSU_SW_DELETE:"rsu_sw_delete",
}
export const US_DATE_FORMAT = "MM/DD/YYYY";
export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const IND_DATE_TIME_FORMAT = "DD-MM-YYYY HH:mm:ss";
export const IND_DATE_FORMAT = "DD/MM/YYYY";
export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_MONTH_YEAR_FORMAT = "DD-MMM-YYYY";

export const CRITICAL_STATUS = "Critical";
export const FAILURE_STATUS = "Failure";
export const ERROR_STATUS = "Error";
export const WARNING_STATUS = "Warning";
export const INFO_STATUS = "Info";

export const FROM_DATE_APPEND_HH_MM_SS = " 00:00:00";
export const TO_DATE_APPEND_HH_MM_SS = " 23:59:59";

export const GENERIC_ERROR_MESSAGE = "Failed - Due to Technical error, Please try again";
export const METERING = "Metering";
export const NO_DATA_FOUND ="No Data Found";

export const MSG_RANGE_BEYOND_14DAYS = "Selected date range is beyond 14 days interval, Please select date range within 14 days.";
export const MSG_FROM_GREATER_THAN_TO = "End Date should be greater than Start Date";
export const MSG_RESUBMIT_FILTERS = "Request overloaded. Please change the filter and resubmit the request.";

// Common error messages used across RSU modules
export const GENERIC_MESSAGE = "Failed due to a technical error, please try again later";
export const GENERIC_FAILED_ERROR = "Connection timed out. Please try again after some time.";

export const dateTimeRegex = /\.\d+$/;

export const COLOR_PALETTE = [
        '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd',
        '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf',
        '#aec7e8', '#ffbb78', '#98df8a', '#ff9896', '#c5b0d5',
        '#c49c94', '#f7b6d2', '#c7c7c7', '#dbbd22'
    ];